export class CostRecordMetadata {
    'type';
    'dataTransfer';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "CostRecordMetadataType",
            "format": ""
        },
        {
            "name": "dataTransfer",
            "baseName": "dataTransfer",
            "type": "CostRecordMetadataDataTransfer",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostRecordMetadata.attributeTypeMap;
    }
    constructor() {
    }
}
